<div class="container-fluid flex flex-auto flex-col space-y-4">
	<div class="mt-4 flex flex-row items-start space-x-8">
		<app-time-range-picker
			[(range)]="this.range"
			[allowDynamic]="true"
			[disabled]="(timeLoading$ | async) || editMode.value || selected.value?.length > 0"
		></app-time-range-picker>
		<ng-container *ngIf="time$stats | async as stats">
			<div class="flex items-center space-x-10">
				<div class="flex flex-col space-y-1">
					<h4
						class="mat-hint font-semibold"
						translate
					>
						reports.total
					</h4>
					<span class="text-2xl">{{ stats.summed | parseMsAsDuration }}</span>
				</div>
				<div class="flex flex-col space-y-1">
					<h4
						class="mat-hint font-semibold"
						translate
					>
						reports.billable-hours
					</h4>
					<span class="text-2xl">{{ stats.billed | parseMsAsDuration }}</span>
				</div>
				<ng-container *ngIf="stats$ | async as s">
					<div
						[matTooltipTemplate]="scheduleTooltip"
						[matTooltipTemplateContext]="{ $implicit: s }"
						class="flex flex-col space-y-1"
						matTooltip
					>
						<h4
							class="mat-hint font-semibold"
							translate
						>
							schedules.name
						</h4>
						<div class="flex items-end space-x-2">
							<span class="text-2xl">{{ s.total.used | parseMsAsDuration }}</span>
							<div class="flex items-end space-x-1">
								<span class="mat-bg-20 mb-0.5 h-4 w-px rotate-6"></span>
								<span class="mat-hint text-sm">{{ s.total.max | parseMsAsDuration }}</span>
							</div>
						</div>
					</div>
				</ng-container>
				<div
					*ngIf="(showAmounts$ | async) && stats.amount as amount"
					class="flex flex-col space-y-1"
				>
					<h4
						class="mat-hint font-semibold"
						translate
					>
						reports.amount
					</h4>
					<span class="text-2xl">{{ amount.value | customCurrency }}</span>
				</div>
			</div>
		</ng-container>
	</div>
	<div class="mt-4 flex h-full min-h-[480px] flex-auto flex-col">
		<mat-card class="data-table-card mat-card-flex h-full">
			<mat-card-header class="sticky-header">
				<ng-container *ngTemplateOutlet="cardEditHeader"></ng-container>
			</mat-card-header>
			<mat-card-content class="flex-auto">
				<div fxHide></div>
				<div class="flex flex-auto flex-col">
					<div
						(matSortChange)="changeDataSort($event)"
						[matSortActive]="activeSort.active"
						[matSortDirection]="activeSort.direction"
						[matSortDisableClear]="true"
						class="mb-2 flex select-none flex-row items-center justify-start gap-2 text-sm font-bold uppercase"
						matSort
					>
						<div class="wflex-[0_0_24px]"></div>
						<div
							class="cursor-pointer py-2 wflex-[1_0_300px]"
							mat-sort-header="name"
						>
							{{ 'time.select' | translate }}
						</div>
						<div class="wflex-[0_0_40px]"></div>
						<div
							class="cursor-pointer py-2 wflex-[0_0_200px] lg:wflex-[0_0_240px] xl:wflex-[0_0_280px]"
							mat-sort-header="user"
						>
							{{ 'dashboard.groupBy.user' | translate }}
						</div>
						<div class="flex items-center space-x-1 wflex-[0_0_220px] md:pr-2">
							<div
								class="cursor-pointer py-2"
								mat-sort-header="project"
							>
								{{ 'project.single' | translate }}
							</div>
							<div class="flex items-center justify-center wflex-[0_0_10px]">&</div>
							<div
								class="cursor-pointer py-2"
								mat-sort-header="task"
							>
								{{ 'task.select' | translate }}
							</div>
						</div>
						<div
							class="cursor-pointer py-2 wflex-[0_0_180px]"
							mat-sort-header="billable"
						>
							{{ 'reports.billable' | translate }}
						</div>
						<div
							class="cursor-pointer py-2 wflex-[0_0_80px]"
							mat-sort-header="tags"
						>
							{{ 'reports.filter-bar.tags' | translate }}
						</div>
						<div
							class="cursor-pointer py-2 wflex-[0_0_100px]"
							mat-sort-header="duration"
						>
							{{ 'timer.time.duration' | translate }}
						</div>
						<div
							*ngIf="showAmounts$ | async"
							class="cursor-pointer py-2 wflex-[0_0_100px]"
							mat-sort-header="amount"
						>
							{{ 'reports.amount' | translate }}
						</div>
						<div
							class="cursor-pointer py-2 wflex-[0_0_200px]"
							mat-sort-header="time"
						>
							{{ 'time.single' | translate }}
						</div>
					</div>
					<ng-container *ngTemplateOutlet="timeLoading ? loadingTimes : editTimes"></ng-container>
				</div>
			</mat-card-content>
		</mat-card>
	</div>
</div>
<ng-template #selectAllButton>
	<button
		(click)="selectAll()"
		[matTooltip]="'utils.select-all-toggle' | translate"
		mat-icon-button
	>
		<mat-icon>select_all</mat-icon>
	</button>
</ng-template>
<ng-template #cardEditHeader>
	<div class="-mx-24px -mt-4 flex h-14 flex-row items-center space-x-2">
		<ng-container *ngTemplateOutlet="selectAllButton"></ng-container>
		<button
			(click)="addEntry()"
			mat-stroked-button
		>
			{{ 'time.create' | translate }}
		</button>
		<button
			(click)="editSelected()"
			[disabled]="selected.value.length <= 0"
			[matTooltip]="selected.value.length > 0 ? ('time.bulk-dialog-title' | translate: { count: selected.value.length }) : null"
			mat-button
		>
			{{ 'time.edit-selected' | translate }}
			<span
				*ngIf="selected.value.length > 0"
				class="mat-hint ml-1"
				>({{ selected.value.length }})</span
			>
		</button>
		<button
			(click)="deleteSelected(bulkDeleteConfirmation)"
			[disabled]="selected.value.length <= 0"
			mat-button
		>
			{{ 'utils.delete' | translate }}
		</button>
	</div>
</ng-template>
<tg-time-edit-popover
	(closed)="onBeforeUpdateTime($event)"
	#timeEditMenu
></tg-time-edit-popover>
<ng-template
	#bulkDeleteConfirmation
	let-data
	let-dialogRef="dialogRef"
>
	<div
		class="flex flex-row items-center justify-start gap-2"
		matDialogTitle
	>
		{{ 'utils.confirmDeletion' | translate }}
	</div>
	<mat-dialog-content>
		<span>{{ 'time.bulk-delete-confirm' | translate: { count: data.entities.length } }}</span>
	</mat-dialog-content>
	<mat-dialog-actions align="end">
		<button
			(click)="dialogRef.close(true)"
			color="warn"
			mat-button
		>
			<span translate>utils.confirm</span>
		</button>
		<button
			(click)="dialogRef.close(false)"
			cdkInitialFocus
			color="primary"
			mat-button
		>
			<span translate>utils.cancel</span>
		</button>
	</mat-dialog-actions>
</ng-template>
<ng-template #loadingTimes>
	<div class="flex flex-col space-y-3">
		<div
			*ngFor="let item of [0, 0, 0, 0, 0, 0]"
			class="flex h-6 flex-row items-center space-x-3"
		>
			<div class="mat-skeleton wflex-[1_0_300px]"></div>
			<div class="mat-skeleton wflex-[0_0_200px] lg:wflex-[0_0_240px] xl:wflex-[0_0_280px]"></div>
			<div class="mat-skeleton wflex-[0_0_220px]"></div>
			<div class="mat-skeleton wflex-[0_0_180px]"></div>
			<div class="mat-skeleton wflex-[0_0_100px]"></div>
			<div class="mat-skeleton wflex-[0_0_100px]"></div>
			<div class="mat-skeleton wflex-[0_0_150px]"></div>
		</div>
	</div>
</ng-template>
<ng-template #editTimes>
	<cdk-virtual-scroll-viewport
		[itemSize]="48"
		[maxBufferPx]="1920"
		[minBufferPx]="960"
		class="-mx-16px h-full"
	>
		<ng-container *cdkVirtualFor="let item of entries$ | async; trackBy: trackId">
			<tg-dashboard-time-entry
				(checkedChange)="toggleSelect(item.id, $event)"
				(dateClick)="timeEditMenu.toggle($event.currentTarget, { time: item.raw })"
				(disabledChange)="item.disabled = $event"
				(entryChange)="updateItem($event)"
				[checked]="item.checked"
				[entry]="item.raw"
				[loading]="isLoading && selected.value.indexOf(item.id) !== -1"
				[showAmount]="showAmounts$ | async"
				[showBulk]="item.currentUserCanEdit"
				class="block px-16px"
			></tg-dashboard-time-entry>
		</ng-container>
	</cdk-virtual-scroll-viewport>
</ng-template>
<ng-template
	#scheduleTooltip
	let-sched
>
	<div class="mat-typography flex flex-col px-3 py-2.5">
		<div class="flex items-center space-x-2">
			<span>{{ sched.name || ('schedules.name' | translate) }}</span>
			<ng-container *ngIf="sched.total.percent >= 0">
				<span class="dot size-1.5"></span>
				<span>{{ sched.total.percent | percent }}</span>
			</ng-container>
		</div>
		<div
			*ngIf="sched.enabledDays?.length && sched.enabledDays as days"
			class="flex items-center gap-x-1"
		>
			<ng-container *ngFor="let d of days">
				<span class="mat-hint">{{ d.currentWeek | dfnsAddDays: d.day | dfnsFormat: 'iii' }}</span>
			</ng-container>
		</div>
	</div>
</ng-template>
